import {fetchPlayerDetail, fetchSettingsRequest, fetchPlayerSeasonStats} from "modules/actions";
import {subscribeToLiveScores} from "modules/actions/checksums/";
import {fetchDashboard} from "modules/actions/dashboard/";
import {getEntryPointData} from "modules/actions/entryActions";
import {globalError} from "modules/actions/errors";
import {fetchGameMessage} from "modules/actions/gameMessage";
import {fetchHelpPage} from "modules/actions/help/";
import {fetchLeaderboard, fetchLeaderProfile} from "modules/actions/leaderboards";
import {fetchLeaders} from "modules/actions/leaders";
import {
	createLeague,
	deleteLeague,
	fetchLeagueById,
	fetchLeaguesToJoin,
	fetchLeagueUsers,
	fetchMyLeagues,
	joinToLeague,
	leaveLeague,
	removeLeagueUser,
	updateLeague,
} from "modules/actions/leagues";
import {
	addPlayer,
	fetchFriendPicks,
	fetchFriendPicksByPlayer,
	fetchPicksHistory,
	fetchPredictions,
	removePick,
	removePlayers,
} from "modules/actions/streak";
import {getHistoryUnitsJson} from "modules/actions/units";
import {
	acceptTerms,
	checkGeo,
	checkTerms,
	checkUserName,
	enableMulliganAction,
	fetchFavoritePlayers,
	fetchFavoriteSquads,
	fetchUserRewards,
	getCountry,
	getSessionUser,
	postLoginViaBackDoor,
	postUserLogout,
	postUserLogoutSuccessDebug,
	saveTooltipInsightsViewState,
	setBannerViewState,
	setGameMessageViewState,
	setSecondTutorialViewState,
	setTooltipModalState,
	setTutorialViewState,
	setViewRewardModal,
	userLogin,
	userLoginWithAcceptTerms, fetchContextualPrompt, declineContextualPrompt, setWeeklyPrizeViewState, viewWinModal,
} from 'modules/actions/user';
import {fetchDashboardSaga} from "modules/sagas/dashboard/";
import {getEntryPointDataSaga} from "modules/sagas/entryPoint";
import {errorsManagerSaga} from "modules/sagas/errors";
import fetchGameMessageSaga from "modules/sagas/gameMessage";
import fetchHelpPageSaga from "modules/sagas/help";
import {fetchLeaderboardsSaga, fetchLeaderProfileSaga} from "modules/sagas/leaderboards";
import {fetchLeadersSaga} from "modules/sagas/leaders";
import {
	createLeagueSaga,
	deleteLeagueSaga,
	fetchLeagueByIdSaga,
	fetchLeaguesToJoinSaga,
	fetchLeagueUsersSaga,
	fetchMyLeaguesSaga,
	joinToLeagueSaga,
	leaveLeagueSaga,
	removeLeagueUserSaga,
	updateLeagueSaga,
} from "modules/sagas/leagues";
import {ChecksumsToSaga} from "modules/sagas/live_score/";
import {fetchPlayerDetailSaga, fetchPlayerSeasonStatsSaga} from "modules/sagas/playerDetail";
import {fetchSettingSaga, viewWinModalSaga} from "modules/sagas/settings";
import addPlayerSaga, {
	fetchFriendPicksByPlayerSaga,
	fetchFriendPicksSaga,
	fetchPicksHistorySaga,
	fetchPredictionsSaga,
	removePlayerSaga,
	removePlayersSaga,
} from "modules/sagas/streak";
import {fetchHistoryUnitsSaga} from "modules/sagas/units";
import {
	acceptTermsSaga,
	checkGeoSaga,
	checkTermsSaga,
	checkUserNameSaga,
	enableMulliganSaga,
	fetchFavoritePlayersSaga,
	fetchFavoriteSquadsSaga,
	fetchUserRewardsSaga,
	getCountrySaga,
	processLoginSaga,
	processLogoutSaga,
	processLogoutSagaDebug,
	processSessionSaga,
	processWithBackdoorSaga,
	setViewRewardModalSaga,
	updateBannerViewStateSaga,
	updateGameMessageViewStateSaga,
	updateSecondTutorialViewStateSaga,
	updateTooltipInsightsViewStateSaga,
	updateTooltipViewStateSaga,
	updateTutorialViewStateSaga,
	userLoginWithAcceptTermsSaga, updateWeeklyPrizeViewStateSaga,
} from 'modules/sagas/user';
import {all, takeLatest} from "redux-saga/effects";
import {takeEvery} from "typed-redux-saga";
import {fetchContextualPromptSaga, declineContextualPromptSaga} from 'modules/sagas/contextualPrompt';
import {fetchWeeklyPrizeModal} from 'modules/actions/weeklyPrizeModal';
import fetchWeeklyPrizeModalSaga from 'modules/sagas/weeklyPrizeModal';

export const rootSaga = function* (): Generator {
	yield all([
		takeLatest(getEntryPointData, getEntryPointDataSaga),
		takeLatest(globalError, errorsManagerSaga),
		takeLatest(userLogin, processLoginSaga),
		takeLatest(userLoginWithAcceptTerms, userLoginWithAcceptTermsSaga),
		takeLatest(checkTerms, checkTermsSaga),
		takeLatest(acceptTerms, acceptTermsSaga),
		takeLatest(checkUserName, checkUserNameSaga),
		takeLatest(checkGeo, checkGeoSaga),
		takeLatest(getCountry, getCountrySaga),
		takeLatest(postLoginViaBackDoor, processWithBackdoorSaga),
		takeLatest(getSessionUser, processSessionSaga),
		takeLatest(postUserLogout, processLogoutSaga),
		takeLatest(postUserLogoutSuccessDebug, processLogoutSagaDebug),
		takeEvery(fetchPredictions, fetchPredictionsSaga),
		takeLatest(addPlayer, addPlayerSaga),
		takeLatest(removePick, removePlayerSaga),
		takeLatest(removePlayers, removePlayersSaga),
		takeLatest(fetchPicksHistory, fetchPicksHistorySaga),
		takeLatest(fetchFriendPicks, fetchFriendPicksSaga),
		takeLatest(fetchLeaders, fetchLeadersSaga),
		takeLatest(fetchDashboard, fetchDashboardSaga),
		takeLatest(subscribeToLiveScores, ChecksumsToSaga),
		takeLatest(enableMulliganAction, enableMulliganSaga),
		takeLatest(fetchHelpPage, fetchHelpPageSaga),
		takeLatest(fetchFavoritePlayers, fetchFavoritePlayersSaga),
		takeLatest(fetchFavoriteSquads, fetchFavoriteSquadsSaga),
		takeLatest(fetchFriendPicksByPlayer, fetchFriendPicksByPlayerSaga),
		takeLatest(setTutorialViewState, updateTutorialViewStateSaga),
		takeLatest(setBannerViewState, updateBannerViewStateSaga),
		takeLatest(saveTooltipInsightsViewState, updateTooltipInsightsViewStateSaga),
		takeLatest(setSecondTutorialViewState, updateSecondTutorialViewStateSaga),
		takeLatest(setWeeklyPrizeViewState, updateWeeklyPrizeViewStateSaga),
		takeLatest(setTooltipModalState, updateTooltipViewStateSaga),
		takeLatest(fetchPlayerDetail, fetchPlayerDetailSaga),
		takeLatest(fetchPlayerSeasonStats, fetchPlayerSeasonStatsSaga),
		takeLatest(fetchGameMessage, fetchGameMessageSaga),
		takeLatest(setGameMessageViewState, updateGameMessageViewStateSaga),
		takeLatest(getHistoryUnitsJson, fetchHistoryUnitsSaga),
		takeLatest(fetchLeaderboard, fetchLeaderboardsSaga),

		takeLatest(createLeague, createLeagueSaga),
		takeLatest(updateLeague, updateLeagueSaga),
		takeLatest(deleteLeague, deleteLeagueSaga),
		takeLatest(leaveLeague, leaveLeagueSaga),
		takeLatest(fetchMyLeagues, fetchMyLeaguesSaga),
		takeLatest(fetchLeaguesToJoin, fetchLeaguesToJoinSaga),
		takeLatest(joinToLeague, joinToLeagueSaga),
		takeLatest(fetchLeagueById, fetchLeagueByIdSaga),
		takeLatest(fetchLeagueUsers, fetchLeagueUsersSaga),
		takeLatest(removeLeagueUser, removeLeagueUserSaga),

		takeLatest(fetchLeaderProfile, fetchLeaderProfileSaga),
		takeLatest(fetchUserRewards, fetchUserRewardsSaga),
		takeLatest(setViewRewardModal, setViewRewardModalSaga),
		takeLatest(fetchSettingsRequest, fetchSettingSaga),
		takeLatest(fetchContextualPrompt, fetchContextualPromptSaga),
		takeLatest(declineContextualPrompt, declineContextualPromptSaga),
		takeLatest(fetchWeeklyPrizeModal, fetchWeeklyPrizeModalSaga),
		takeLatest(viewWinModal, viewWinModalSaga),
	]);
};

export * from "modules/sagas/errors";
